import {useQuery, useQueryClient} from 'react-query'
import {Contest_SiteEventEditModalForm} from './Contest_SiteEventEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'

const Contest_SiteEventEditModalFormWrapper = () => {
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  // const {
  //   isLoading,
  //   data: contest_SiteEvent,
  //   error,
  // } = useQuery(
  //   `${QUERIES.PARAMETER_LIST}-parameter-${itemIdForUpdate}`,
  //   () => {
  //     return getParameterById(itemIdForUpdate)
  //   },
  //   {
  //     cacheTime: 0,
  //     enabled: enabledQuery,
  //     onError: (err) => {
  //       setItemIdForUpdate(undefined)
  //       console.error(err)
  //     },
  //   }
  // )


  if (!itemIdForUpdate) {
    return <Contest_SiteEventEditModalForm  contest_SiteEvent = {{ id: undefined}} />
  }

  return null
}

export {Contest_SiteEventEditModalFormWrapper}
